import { render, staticRenderFns } from "./CoverageItem.vue?vue&type=template&id=8e03fdb4&"
import script from "./CoverageItem.vue?vue&type=script&lang=js&"
export * from "./CoverageItem.vue?vue&type=script&lang=js&"
import style0 from "./CoverageItem.vue?vue&type=style&index=0&id=8e03fdb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports